import img2 from '../images/slider/slide_2.png';
import imgbg2 from '../images/slider/bg_slide_2.png'


const heroSliderData = [
    {
        title_1: "Get Continuous Rewards",
        title_2: "Stake. Govern. Support.",
        description: "Get Rewards for Staking Your Coins and Supporting Ecosystems",
        img: img2,
        imgbg: imgbg2,
        class: 'center'
    },
]

export default heroSliderData;
